/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_DescriptionInputs */

const en_settings_credits_description = /** @type {(inputs: Settings_Credits_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your credits balance and history`)
};

/**
* | output |
* | --- |
* | "Your credits balance and history" |
*
* @param {Settings_Credits_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_credits_description = /** @type {((inputs?: Settings_Credits_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_credits_description(inputs)
});
export { settings_credits_description as "settings.credits.description" }